import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { setOpenPopup } from '#action/project/devices-popup';
import DevicePopup from '#component/device/devices-popup/device-popup-project';
import ArrowRightButton from '#component/general/arrow-right-button';
import { ShowMoreContainer } from '#component/user/dashboard/styles';

const DevicesCountButton = ({ devicesCount, project, user }) => {
  const dispatch = useDispatch();
  const [openDevicePopup, setOpenDevicePopup] = useState(false);

  const handleOpenDevicePopup = () => {
    setOpenDevicePopup(!openDevicePopup);
    dispatch(setOpenPopup(!openDevicePopup, false));
  };

  if (!devicesCount && !openDevicePopup) {
    return null;
  }

  return (
    <>
      <ShowMoreContainer>
        <Typography color="textSecondary" fontWeight="bold">
          {devicesCount}
        </Typography>
        <ArrowRightButton onClickArrowRight={handleOpenDevicePopup} />
      </ShowMoreContainer>
      {(openDevicePopup) &&
        <DevicePopup
          project={project}
          open={openDevicePopup}
          openedFromCreateForm={false}
          handleOpenPopupExternal={setOpenDevicePopup}
          user={user}
        />}
    </>
  );
};

export default DevicesCountButton;
